module.exports = __webpack_public_path__ + "static/fonts/Lato-BoldItalic.1ba4767e.ttf";